// src/contexts/BrokerContext.js
import React, { createContext, useState, useContext } from 'react';

// Create the Context
export const BrokerContext = createContext(null);

// Create a Provider component
export const BrokerProvider = ({ children }) => {
  const [brokerDetails, setBrokerDetails] = useState(null); // Will store the fullresponse

  const updateBrokerDetails = (data) => {
    setBrokerDetails(data);
  };

  return (
    <BrokerContext.Provider value={{ brokerDetails, updateBrokerDetails }}>
      {children}
    </BrokerContext.Provider>
  );
};

// Custom hook to easily consume the context
export const useBroker = () => {
  const context = useContext(BrokerContext);
  if (context === undefined) {
    throw new Error('useBroker must be used within a BrokerProvider');
  }
  return context;
};